/* 
  Sorts the data based on both date and time.
  < input = filteredData >
  < output = sortedData > 
*/

export function sortingData(filteredData) {
  const sortedData = filteredData.slice().sort((a, b) => {
    const dateA = new Date(a.date.replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1T$4:$5:$6'));
    const dateB = new Date(b.date.replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1T$4:$5:$6'));

    return dateB - dateA;
  });

  return sortedData;
}

/* 
  Filters the data (based on the status useState)
  < input = status (useState), data (All)>
  < output = filteredAndSortedData > 
*/

export function filterDataByStatus(status, data) {
  if (status === "All") {
    return sortingData(data);
  } else {
    return sortingData(data.filter((item) => item.status === status));
  }
}
